import React, { useEffect, useRef } from "react";
import { motion, useInView, useReducedMotion } from "framer-motion";
import { ArrowDownRightIcon } from "lucide-react";
type NudgeArrowProps = {
  /** Seconds before the first nudge, so it starts after the heading lands */
  delay?: number;
};
const NUDGE = 7;

/**
 * The diagonal heading arrow with its periodic nudge.
 * The loop only runs while the arrow is on screen.
 */
export function NudgeArrow({
  delay = 0
}: NudgeArrowProps) {
  const reduce = useReducedMotion();
  const ref = useRef<HTMLSpanElement>(null);
  const inView = useInView(ref, {
    margin: "80px"
  });
  const firstRun = useRef(true);
  const active = !reduce && inView;
  useEffect(() => {
    if (active) firstRun.current = false;
  }, [active]);
  return <motion.span ref={ref} className="block" animate={active ? {
    x: [0, NUDGE, 0],
    y: [0, NUDGE, 0]
  } : {
    x: 0,
    y: 0
  }} transition={active ? {
    duration: 0.7,
    times: [0, 0.4, 1],
    ease: [0.45, 0, 0.55, 1],
    repeat: Infinity,
    repeatDelay: 1,
    delay: firstRun.current ? delay : 0.4
  } : {
    duration: 0.2,
    ease: [0.23, 1, 0.32, 1]
  }} data-id="element-298" data-mp="wzux9yfdz5cn">
      <ArrowDownRightIcon className="h-[clamp(2rem,5vw,5rem)] w-[clamp(2rem,5vw,5rem)] text-espresso" strokeWidth={1.25} data-id="element-299" data-mp="phgd8x09qcmo" />
    </motion.span>;
}